var BlockView = require('views/block/base-block-view');
var FeedbackService = require('services/feedback-service');
var EvaluationService = require('services/evaluation-service');

var PollResultsView = BlockView.extend({
  template: 'poll-results',
  DEFAULT_COLOURS: ['#0074D9', '#FEBC39', '#3FD060'],
  load: function() {
    let pickOptions = ['slug', 'sectionIndex', 'questionIndex', 'show_legend', 'show_question', 'show_percentage', 'legend_colors', 'vertical_display', 'horizontal_display'];
    this.pollResults = new EF.Models.PollResults(_.pick(this.model.attributes, pickOptions));

    this.pollResults.set('response_set', EvaluationService.getResponseSet(this.model.get('slug')));
    let options = EF.options.local ? {} : {
        parse: true,
        headers: {'Authorization': `Bearer ${this.pollResults.get('response_set').token}`}
      };
    this.pollResults.loadPollResults(options).done(() => {
      if(this.pollResults.get('sectionIndex') !== undefined) {
        if(this.pollResults.get('questionIndex') !== undefined) {
          this.pollResults.filterQuestionsBySectionAndQuestion(this.pollResults.get('sectionIndex'), this.pollResults.get('questionIndex'));
        } else {
          this.pollResults.filterQuestionsBySection(this.pollResults.get('sectionIndex'));
        }
      } else {
        this.pollResults.filterQuestionsBySectionAndQuestion(0, 0);
      }

      // Check for vertical/horizontal display; If no one is specified, we use vertical display by default
      if(!this.model.get('vertical_display') && !this.model.get('horizontal_display')) {
        this.model.set('vertical_display', true);
      }

      // Check for percentage option, if isn't specified we set it 'true' by default                      
      if(this.model.get('show_percentage') !== false) {
        this.model.set('show_percentage', true);
      }

      this.model.set('sections', this.pollResults.get('sections'));
      this.model.get('sections').forEach((s) => {
        s.get('questions').forEach((q) => {
          let total = q.get('answers').reduce((a, b) => a + parseInt(b.count), 0);
          let answers = q.get('answers');

          // if there is no list of colors passed to component, we use the default one                
          let legend_colors = this.pollResults.get('legend_colors') || this.DEFAULT_COLOURS;
          for(var i = 0; i < answers.length; i++) {
            answers[i].percent = ((answers[i].count / total) * 100) >> 0;
            answers[i].color = legend_colors[i] ? legend_colors[i] : this.DEFAULT_COLOURS[0];
          }
        });
      });

      this.render();
    });
    this.renderFeedback();
  },
  play: function() {
    this.readyToGo();
  },
  renderFeedback: function() {
    FeedbackService.renderFeedbackWithElementState(this.model.get('feedback'), this.$el, 'passed', ['passed']);
  }
});

module.exports = PollResultsView;
